import { OnInit, SimpleChanges } from '@angular/core';
import * as strftime from 'strftime';
var DateDisplayerComponent = /** @class */ (function () {
    function DateDisplayerComponent() {
    }
    DateDisplayerComponent.prototype.ngOnInit = function () {
    };
    DateDisplayerComponent.prototype.ngOnChanges = function (changes) {
        var date = changes.date.currentValue;
        this.day = strftime('%d', date),
            this.month = strftime('%b', date),
            this.year = strftime('%Y', date);
    };
    DateDisplayerComponent.prototype.shouldShow = function (s) {
        return this.show.indexOf(s) > -1;
    };
    return DateDisplayerComponent;
}());
export { DateDisplayerComponent };
//# sourceMappingURL=date-displayer.component.js.map